import React, { FC } from 'react';
import styles from './FilterSwitchItem.module.scss';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Switch from '@/components/UI/switch/Switch';
import { IconNames } from '@/components/UI/Types';
import Typography from '@/components/UI/typography/Typography';
interface FilterSwitchItemTypes {
  icon: IconNames;
  title: string;
  descrpition?: string;
  handleChange: () => void;
  checked: boolean;
}
const FilterSwitchItem: FC<FilterSwitchItemTypes> = ({
  icon,
  title,
  descrpition,
  handleChange,
  checked
}) => {
  return <Box className={styles['filter-switch-item-container']} data-sentry-element="Box" data-sentry-component="FilterSwitchItem" data-sentry-source-file="FilterSwitchItem.tsx">
      <Box className={styles['filter-switch-item-right']} data-sentry-element="Box" data-sentry-source-file="FilterSwitchItem.tsx">
        <Icon name={icon} type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="FilterSwitchItem.tsx" />
        <Box data-sentry-element="Box" data-sentry-source-file="FilterSwitchItem.tsx">
          <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="FilterSwitchItem.tsx">{title}</Typography>
          <Typography variant="bodyM" component="p" className={styles['filter-switch-item-description']} data-sentry-element="Typography" data-sentry-source-file="FilterSwitchItem.tsx">
            {descrpition}
          </Typography>
        </Box>
      </Box>
      <Box data-sentry-element="Box" data-sentry-source-file="FilterSwitchItem.tsx">
        <Switch checked={checked} onChange={handleChange} size="small" data-sentry-element="Switch" data-sentry-source-file="FilterSwitchItem.tsx" />
      </Box>
    </Box>;
};
export default FilterSwitchItem;